"use client";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "../styles/result-card-grid.css";
import { GridCardInfo } from "./GridCardInfo";
import { GridCardTitle } from "./GridCardTitle";
import { ListCompanyInfo } from "./ListCompanyInfo";

const ResultCardListItem = ({ result, allMemberships }) => {
  // Get primary membership (current role or most recent)
  const currentMemberships = allMemberships?.filter((m) => !m.end_date) || [];
  const primaryMembership = currentMemberships[0] || allMemberships?.[0];

  const isSubscriber = result.subscriber === true;

  return (
    <Card
      className="hover-card mb-3"
      style={{
        backgroundColor: isSubscriber ? "#fffcf3" : "white",
        border: isSubscriber ? "1px solid #e9ecef" : "none",
        position: "relative",
      }}
    >
      {isSubscriber && (
        <div
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            zIndex: 10,
          }}
        >
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="open-for-work-tooltip-list">Open to work</Tooltip>
            }
          >
            <i
              className="fa fa-briefcase"
              style={{
                color: "#e47136",
                fontSize: "16px",
                backgroundColor: "white",
                padding: "6px",
                borderRadius: "50%",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                cursor: "help",
              }}
            />
          </OverlayTrigger>
        </div>
      )}

      <Card.Body className="pl-3 pr-3 pt-3 pb-2">
        <Row style={{ margin: 0 }}>
          <Col md={4} sm={12}>
            <div style={{ paddingRight: "15px" }}>
              <GridCardTitle
                id={result.id}
                name={result.name}
                extraClass="mb-0 pb-0"
                primaryMembership={primaryMembership}
              />

              <GridCardInfo
                result={result}
                allMemberships={allMemberships}
                hideCompanyInfo={true} // You can use this prop in GridCardInfo to conditionally hide company info
              />
            </div>
          </Col>
          {/* Right column: empty for now */}
          <Col md={8} sm={12}>
            <ListCompanyInfo
              id={result.id}
              name={result.name}
              allMemberships={allMemberships}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ResultCardListItem;
